import {apiGet} from '@api/api'

export const apiGetNotificationCount = async () => {
    return await apiGet<number>(`notifications/count`)
}
